module.exports = __webpack_public_path__ + "media/images/manage-offer/paperclip-b1683648b147a58c41b64e03bdd59664.png";